import { TOGGLE_MASK } from '../actions';

export const toggleMask = (showMask) => ({
  type: TOGGLE_MASK,
  payload: showMask,
});
